module.exports = __webpack_public_path__ + "img/noData.9513cce5.png";